import { render, staticRenderFns } from "./employeeDetailsDialog.vue?vue&type=template&id=0641a7ac&scoped=true"
import script from "./employeeDetailsDialog.vue?vue&type=script&lang=js"
export * from "./employeeDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./employeeDetailsDialog.vue?vue&type=style&index=0&id=0641a7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641a7ac",
  null
  
)

export default component.exports